import './products-carousel.css';
import 'swiper/css';
import { Swiper, Navigation, Keyboard, A11y } from 'swiper';

export default () => {
  const init = () => {
    if (!customElements.get("products-carousel")) {
      customElements.define("products-carousel", ProductsCarousel);
    }
  };

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = this.querySelector(".image-products-slider");
    }

    initializeSwiper() {
      window.addEventListener('DOMContentLoaded', () => {
        const element = this.querySelector(".image-products-slider")
        element.querySelectorAll('.swiper-slide').forEach((el) => {
          if (el.classList.contains('swiper-slide-active')) {
            el.setAttribute('aria-hidden', 'false');
          } else {
            el.setAttribute('aria-hidden', 'true');
          }
        })
      })

      if (this.mainSlider) {
        // eslint-disable-next-line
        new Swiper(this.mainSlider, {
          loop: false,
          slidesPerView: 5,
          spaceBetween:16,
          modules: [Navigation, Keyboard, A11y],
          a11y: { enabled: true },
          keyboard: { enabled: true, onlyInViewport: true },
          freeMode: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            300: {
              slidesPerView: 1,
            },
            500: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 3.8,
            },
            1200: {
              slidesPerView: 5,
            }
          }
        });
      }
    }

    connectedCallback() {
      this.initializeSwiper();
    }
  }

  init();
}
